angular.module('core').filter('level', ['localeService', 'translateFilter',
    function(localeService, translateFilter) {
        return function(levelId) {
            if(_.isString(levelId)) {
                levelId = parseInt(levelId);
            }

            if( _.isNaN(levelId) || _.isUndefined(levelId) ) {
                return '';
            }

            switch (levelId) {
                case -1:
                    return translateFilter('levels.preK');
                case 0:
                    return translateFilter('levels.kindergarten');
                case 9:
                    return translateFilter('levels.algebra');
                case 1001:
                    // 1001 is the code for "other"
                    return "";
                default:
                    var gradeNumber = localeService.getLocale() === 'en-gb' ? levelId + 1 : levelId;
                    return translateFilter('levels.grade', {number: gradeNumber});
            }
        };
    }
]);
